import './App.css';
import RandomInsultGenerator from './RandomInsultGenerator';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <RandomInsultGenerator/>
      <Footer/>
    </div>
  );
}

export default App;
